// Studyo Today Backend
// Package studyo.today.planners.v1.resources
// Resource definitions
// Copyright (c) 2015-2023 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/planners/v1/resources/published_work_details.proto (package studyo.today.planners.v1.resources, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import { file_studyo_today_schools_v1_resources_published_work } from "@buf/studyo_studyo-today-schools.bufbuild_es/studyo/today/schools/v1/resources/published_work_pb.js";

/**
 * Describes the file studyo/today/planners/v1/resources/published_work_details.proto.
 */
export const file_studyo_today_planners_v1_resources_published_work_details = /*@__PURE__*/
  fileDesc("Cj9zdHVkeW8vdG9kYXkvcGxhbm5lcnMvdjEvcmVzb3VyY2VzL3B1Ymxpc2hlZF93b3JrX2RldGFpbHMucHJvdG8SInN0dWR5by50b2RheS5wbGFubmVycy52MS5yZXNvdXJjZXMiewoUUHVibGlzaGVkV29ya0RldGFpbHMSSAoOcHVibGlzaGVkX3dvcmsYASABKAsyMC5zdHVkeW8udG9kYXkuc2Nob29scy52MS5yZXNvdXJjZXMuUHVibGlzaGVkV29yaxIZChFjb3Vyc2Vfc2VjdGlvbl9pZBgCIAEoCUIqqgInU3R1ZHlvLlRvZGF5LlBsYW5uZXJzLkdycGMuVjEuUmVzb3VyY2VzYgZwcm90bzM", [file_studyo_today_schools_v1_resources_published_work]);

/**
 * Describes the message studyo.today.planners.v1.resources.PublishedWorkDetails.
 * Use `create(PublishedWorkDetailsSchema)` to create a new message.
 */
export const PublishedWorkDetailsSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_planners_v1_resources_published_work_details, 0);

